import React from "react";
import Hero from "@/components/site/Hero";
import DiversBreak from "@/components/site/DiversBreak";
import DreamTimeline from "@/components/site/DreamTimeline";
import ReelsVideo from "@/components/site/ReelsVideo";
import ImagineSection from "@/components/site/ImagineSection";
import Boat from "@/components/site/Boat";
import Gallery from "@/components/site/Gallery";
import Reviews from "@/components/site/Reviews";
import Inclusions from "@/components/site/Inclusions";
import Availability from "@/components/site/Availability";
import Pricing from "@/components/site/Pricing";
import SummerValue from "@/components/site/SummerValue";
import Guarantee from "@/components/site/Guarantee";
import FAQ from "@/components/site/FAQ";
import MapSection from "@/components/site/MapSection";
import Footer from "@/components/site/Footer";
import SocialFloat from "@/components/site/SocialFloat";

export default function Landing() {
  return (
    <main className="relative w-full bg-white" data-testid="landing-page">
      <Hero />
      <DiversBreak />
      <DreamTimeline />
      <ReelsVideo />
      <ImagineSection />
      <Inclusions />
      <Pricing />
      <Availability />
      <Gallery />
      <Boat />
      <Reviews />
      <SummerValue />
      <Guarantee />
      <FAQ />
      <MapSection />
      <Footer />
      <SocialFloat />
    </main>
  );
}
